import React, { Component } from 'react';
import { Col, Container, Row } from 'reactstrap';
import Categories from './components/Categories';
import { connect } from 'react-redux';
import BlogTeam from './components/BlogTeam';
import ManageBlog from './components/ManageBlog';
import BasicSettings from './components/BasicSettings';
import OpenGraph from './components/OpenGraph';
import Statistics from './components/Statistics';
import AdSense from './components/AdSense';
import ImportPosts from './components/ImportPosts';
import { Prompt } from 'react-router';
import { isDirty, initialize } from 'redux-form';
import validateSettingsField from './validator/validateSettingsFields';
import withErrorNotification from '../../hof/withErrorNotification';
import { Blogs } from '../../services/Blogs';
import Notifications from '../../hof/notifications';
import { initCurrentBlog, fetchBlogs, prepareBlogSettingsForm } from '../../redux/actions/blogsActions';
import SocialProfiles from './components/SocialProfiles';
import OnesignalNotifications from './components/OnesignalNotifications';
import ThemeSettings from './components/ThemeSettings';
import {withTranslation} from "react-i18next";
import {translate} from "../../translations/i18n";
import MainImageCard from "./components/MainImage";
import HiddenCommenters from './components/HiddenCommenters';

const handleSaveSettings = async (values, dispatch) => {

  validateSettingsField(values);

  const blogId = localStorage.getItem('blog');

  await withErrorNotification(async () => {
    const { blog } = await Blogs.updateBlogSettings(blogId, values);
    Notifications.showNotification(translate('settings.notifications.save.success.title'), translate('settings.notifications.save.success.body'), "success");
    dispatch(initCurrentBlog(blog._id));
    dispatch(fetchBlogs());
  })

}

class SettingsPage extends Component {

  componentDidMount = () => {
    const { blogs, doInitBlog } = this.props;
    doInitBlog(blogs.blog);
  }


  render() {

    const { t } = this.props;

    return (
      <Container className="dashboard">
        <Prompt when={this.props.isDirty} message={t('settings.you_have_unsaved_changes')} />
        <Row>
          <Col md={12}>
            <h3 className="page-title">{t('settings.title')}</h3>
          </Col>
          <Col lg={9} md={12}>
            <Row>
              <BasicSettings blog={this.props.blogs.blog} />
              <ThemeSettings blog={this.props.blogs.blog} />
              <Categories blog={this.props.blogs.blog} />
              <SocialProfiles blog={this.props.blogs.blog} />
              <OpenGraph blog={this.props.blogs.blog} />
              <Statistics blog={this.props.blogs.blog} />
              <AdSense blog={this.props.blogs.blog} />
              <OnesignalNotifications blog={this.props.blogs.blog} />
              <HiddenCommenters blog={this.props.blogs.blog} />
              <ImportPosts blog={this.props.blogs.blog} />
            </Row>
          </Col>

          <Col lg={3} md={12}>
            <Row>
              {/* <BuyCustomDomain /> */}
              <BlogTeam you={this.props.auth.username} owner={this.props.blogs.blog.owner} collaborators={this.props.blogs.blog.collaborators} blogId={this.props.blogs.blog._id} />
              <MainImageCard />
              <ManageBlog blogId={this.props.blogs.blog._id} handleSaveSettings={handleSaveSettings} />
            </Row>
          </Col>
        </Row>
      </Container>
    );

  }
}


const mapStateToProps = (state) => {
  return {
    blogs: state.blogs,
    auth: state.auth,
    isDirty: isDirty('blog_settings')(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    doInitBlog: (blog) => { dispatch(initialize('blog_settings', prepareBlogSettingsForm(blog))) }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('dashboard')(SettingsPage));
